.container {
	width: 90%;
	max-width: 30rem;
	padding: 2rem;
	gap: 1rem;
}
.calendar {
	width: 100% !important;
	min-width: fit-content;
	max-width: 25rem;
}
.date {
	width: 100%;
}
/* .input input {
	width: 100%;
} */
.input {
	width: 100%;
	max-width: 25rem;
}
.data ul {
	/* 	overflow: hidden !important;
 */
	gap: 5px;
	display: flex;
	flex-direction: column;
	padding-bottom: 5px;
}

.data ul li {
	margin: 0;
	padding: 0 2px;
	min-width: fit-content;
}
.data ul li > span {
	display: grid;
	place-items: center;
	grid-template-columns: 1fr 16px;
	margin: 0;
	width: 100%;
}
.panel-body {
	overflow: hidden !important;
}
.panelDate {
	width: 100%;
	overflow: hidden;
	margin: 0 !important;
}
.panelDate p {
	color: var(--textSecondary);
	overflow: hidden;
}
.panelDate svg {
	width: 16px;
	height: 16px;
}
.tooltiptext {
	visibility: hidden;
	position: absolute;
	height: 20px;
	width: fit-content;
	overflow: visible;
}
.panelDate:first-child:hover ~ .tooltiptext {
	visibility: visible;
}
